import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Uncaught error:", error, errorInfo);

        // Detect stale chunks from old builds
        const isChunkLoadError = error?.name === 'ChunkLoadError';
        const isSyntaxError = error?.name === 'SyntaxError' && error?.message?.includes("Unexpected token '<'");
        
        if (isChunkLoadError || isSyntaxError) {
            const lastReload = sessionStorage.getItem('last_chunk_error_reload');
            const now = Date.now();
            // Prevent infinite reload loops by requiring at least 10s between reloads
            if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
                sessionStorage.setItem('last_chunk_error_reload', now.toString());
                window.location.reload(true);
                return;
            }
        }

        this.setState({ error, errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
                    <div className="bg-gray-800 rounded-xl shadow-2xl p-8 max-w-md w-full border border-gray-700 text-center">
                        <div className="mb-6">
                            <svg className="w-20 h-20 text-red-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                            </svg>
                        </div>
                        <h1 className="text-2xl font-bold text-white mb-2">ขออภัย เกิดข้อผิดพลาด</h1>
                        <p className="text-gray-400 mb-6">
                            ระบบเกิดข้อขัดข้องบางประการ กรุณาลองโหลดหน้าเว็บใหม่อีกครั้ง
                        </p>

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <div className="mb-6 text-left bg-gray-900 p-4 rounded overflow-auto max-h-40 text-xs text-red-300 font-mono">
                                {this.state.error.toString()}
                                <br />
                                {this.state.errorInfo.componentStack}
                            </div>
                        )}

                        <button
                            onClick={this.handleReload}
                            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-4 rounded-lg transition duration-300 transform hover:scale-105"
                        >
                            โหลดหน้าเว็บใหม่
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;